import { create } from 'zustand';
import { ApiUtils, MiscApi, RequestStrategyEnum } from '@shared/api';

interface INationalitiesStore {
  loading: boolean;
  error: string | null;
  nationalities: string[];
  getNationalities: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useNationalitiesStore = create<INationalitiesStore>((set) => ({
  loading: false,
  error: null,
  nationalities: [],

  getNationalities: ApiUtils.wrapperApi(async (signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await MiscApi.getNationalities(signal);
      set({ nationalities: result ?? [], loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ nationalities: [], loading: false, error: null }),
}));
